"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = _interopRequireDefault(require("./Shared/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoWrapper = _styledComponents.default.div.attrs({
  "data-qa": "logo-wrapper"
}).withConfig({
  displayName: "Logo__LogoWrapper",
  componentId: "sc-99wdj-0"
})(["margin-right:21px;height:36px;max-width:153px;width:100%;@media (min-width:", "px){margin-right:61px;}"], function (props) {
  return props.theme.breakpoints.values.md;
});

var _ref2 = _react.default.createElement("a", {
  href: "/",
  target: "_self",
  title: "Carvana"
}, _react.default.createElement(_Icons.default, {
  iconName: "carvanaLogo"
}));

var Logo = function Logo(_ref) {
  var className = _ref.className;
  return _react.default.createElement(LogoWrapper, {
    className: className,
    "data-qa": "logo"
  }, _ref2);
};

Logo.defaultProps = {
  className: ''
};
var _default = Logo;
exports.default = _default;
module.exports = exports.default;